import { useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from '../../../../../components/UI'

import { selectSuccessAddQuiz } from '../../../../../routing/fetchingfunction/quiz/quiz.reducer'
import { resetAddQuizSuccess } from '../../../../../routing/fetchingfunction/quiz/quiz.actions'

const MyQuizTemplatesSuccessModal = () => {
  const dispatch = useDispatch()

  const isOpen = useSelector(selectSuccessAddQuiz)

  const handleClose = () => {
    dispatch(resetAddQuizSuccess())
  }

  useEffect(() => {
    return () => {
      handleClose()
    }
  }, [])

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FDFDFD] !shadow-modal',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img
          src="/assets/icon/settings-change-success.svg"
          alt="Success"
          className="w-[124px] h-[124px]"
        />

        <h2 className="text-xl font-bold text-primary-100 mt-[16px] text-center">
          New Quiz Template Added!
        </h2>

        <h3 className="mt-[8px] text-sm font-medium text-primary-100 text-center">
          Congratulations! You have successfully added a new quiz template.
        </h3>

        <Button
          className="mt-[24px] w-full h-[44px] flex items-center justify-center shadow-button text-lg font-semibold text-white"
          onClick={handleClose}
        >
          Continue
        </Button>
      </div>
    </Dialog>
  )
}

export default MyQuizTemplatesSuccessModal
